export default __webpack_public_path__ + "static/media/sink-leaking.0f13eab7.jpg";